import { render } from "./materialManager.vue?vue&type=template&id=097be7f0"
import script from "./materialManager.vue?vue&type=script&lang=js"
export * from "./materialManager.vue?vue&type=script&lang=js"

import "./materialManager.vue?vue&type=style&index=0&id=097be7f0&lang=css"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__